import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import CommonDialog from "../CommonDialog";
import { DIALOG_FIELD_TYPES } from "../../common/Stores/constant/constant";
import DialogDelete from "../../common/DialogDelete";
import { postBuilder, fetchBuilderList } from "./service/service";
import {
  fetchBuilder,
  putBuilder,
  deleteBuilder
} from "./shopDetail/service/service";
import { dispatchError } from "common/Stores/service/service";
import { isFurigana, isPhoneNumber, isZipCode } from "utils/validator";

/**
 * CommonDialog の CheckBox は checked = Number(value) === 1 のみ。
 * API は isVerification にタイムスタンプ（例: 1777264417952）を返すことがあるため 0/1 に寄せる。
 */
export const toFormCheckboxInt = v => {
  if (v === false || v === null || v === undefined || v === "" || v === 0 || v === "0") {
    return 0;
  }
  if (v === true || v === 1 || v === "1") return 1;
  const n = typeof v === "number" ? v : Number(v);
  if (!Number.isNaN(n) && n !== 0) return 1;
  return 0;
};

class ShopDialog extends React.Component {
  state = {
    builders: {
      address: null,
      agreeMentDate: null,
      cancellationDate: null,
      contractRenewDate: null,
      furigana: null,
      name: null,
      phone: null,
      uniqueCode: null,
      code: null,
      zipCode: null,
    },
    currentDateStatus: {},
    clientError: null
  };

  defaultValues = {
    name: null,
    furigana: null,
    zipCode: null,
    address: null,
    phone: null,
    agreeMentDate: new Date(),
    contractRenewDate: null,
    cancellationDate: null,
    uniqueCode: null,
    code: null,
    isVerification: 0
  };

  fieldList = [
    {
      name: "code",
      label: "顧客No",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: false
    },
    {
      name: "name",
      label: "顧客名",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: true
    },
    {
      name: "furigana",
      label: "顧客名（ふりがな全角）​",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: true
    },
    {
      name: "zipCode",
      label: "郵便番号​",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: true
    },
    {
      name: "address",
      label: "住所​",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: true
    },
    {
      name: "phone",
      label: "電話番号​",
      type: DIALOG_FIELD_TYPES.Text,
      isRequired: true
    },
    {
      name: "agreeMentDate",
      label: "登録日​",
      type: DIALOG_FIELD_TYPES.DateTime,
      isRequired: true
    },
    {
      name: "contractRenewDate",
      label: "契約更新日​",
      type: DIALOG_FIELD_TYPES.DateTime,
      isRequired: true
    },
    {
      name: "isVerification",
      label: "検証用工務店",
      type: DIALOG_FIELD_TYPES.CheckBox
    },
  ];

  fieldListEdit = [
    ...this.fieldList.filter(field => field.name !== "isVerification"),
    {
      name: "cancellationDate",
      label: "利用停止日",
      type: DIALOG_FIELD_TYPES.DateTime
    },
    {
      name: "isVerification",
      label: "検証用工務店",
      type: DIALOG_FIELD_TYPES.CheckBox
    },
  ];

  componentDidMount() {
    const { isEdit, builderUniqueCode, fetchBuilder, fetchBuilderList } = this.props;
    if (isEdit && builderUniqueCode) {
      fetchBuilder(builderUniqueCode);
    }
    fetchBuilderList();
  }

  componentWillUnmount() {
    this.props.dispatchError("");
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.builders !== nextProps.builder &&
      nextProps.builder &&
      nextProps.builder.uniqueCode === nextProps.builderUniqueCode
    ) {
      this.setState({
        builders: {
          ...nextProps.builder,
          isVerification: toFormCheckboxInt(nextProps.builder.isVerification)
        }
      });
    }
  }

  toggleDialogDelete = () => {
    this.props.toggleDialogDelete();
  };

  onSubmit = valuesForm => {
    const { currentDateStatus } = this.state;
    const { isEdit, builderUniqueCode, putBuilder, postBuilder, builders } = this.props;

    let clientError = null;
    const rawCode = valuesForm.code == null ? "" : String(valuesForm.code);
    if (rawCode !== "" && /\s/.test(rawCode)) {
      clientError = { ...clientError, code: "顧客Noに空白文字は使用できません" };
    }
    if (!clientError && rawCode !== "" && Array.isArray(builders)) {
      const duplicated = builders.some(
        b => b.code === rawCode && (!isEdit || b.uniqueCode !== builderUniqueCode)
      );
      if (duplicated) {
        clientError = { ...clientError, code: "この顧客Noは既に使用されています" };
      }
    }
    this.setState({ clientError });
    if (clientError) return;

    // NOTE: Null validation.
    let isValidated = false;
    for (const key in valuesForm) {
      // NOTE: Validate null
      if (
        (key === 'name' || key === 'furigana' || key === 'zipCode' || key === 'address' || key === 'phone' || key === 'agreeMentDate' || key === 'contractRenewDate') &&
        !valuesForm[key]
      ) {
        console.log(`${key} is null!`);
        isValidated = true;
        return;
      }
      if (!!isEdit && (key === 'uniqueCode' ) && !valuesForm[key]) {
        console.log(`${key} is null!`);
        isValidated = true;
        return;
      }

      // NOTE: Validate furigana.
      if (key === 'furigana' && !isFurigana(valuesForm[key])) {
        console.log(`${key} is not FURIGANA!`);
        isValidated = true;
        return;
      }

      // NOTE: Validate phone
      if (key === 'phone' && !isPhoneNumber(valuesForm[key])) {
        console.log(`${key} is not PHONE_NUMBER!`);
        isValidated = true;
        return;
      }

      // NOTE: Validate zipCode
      if (key === 'zipCode' && !isZipCode(valuesForm[key])) {
        console.log(`${key} is not ZIP_CODE!`);
        isValidated = true;
        return;
      }
    }
    if (!!isValidated) return;

    for (let key in currentDateStatus) {
      valuesForm[key] = "Invalid Date";
    }
    if (isEdit) {
      putBuilder(builderUniqueCode, { ...valuesForm }, () => {
        alert("エラーが発生しました。 お手数ですが、再度お試しください。");
        this.props.history.go(0);
      });
    } else {
      postBuilder(valuesForm, () => {
        alert("エラーが発生しました。 お手数ですが、再度お試しください。");
        this.props.history.go(0);
      });
    }
  };

  onDeleteSubmit = () => {
    this.props.deleteBuilder(this.props.builderUniqueCode, () => {
      alert("エラーが発生しました。 お手数ですが、再度お試しください。");
      this.props.history.go(0);
    });
  };

  currentDate = (fieldName, date) => {
    if (date?.toString() === "Invalid Date") {
      this.setState({
        currentDateStatus: {
          ...this.state.currentDateStatus,
          [fieldName]: ""
        }
      });
    } else {
      const newDateStatus = { ...this.state.currentDateStatus };
      delete newDateStatus[fieldName];
      this.setState({
        currentDateStatus: newDateStatus
      });
    }
  };

  getMessage = (key, message) => {
    return message[key];
  };

  getFormInitialValues = () => {
    const { isEdit, builder, builderUniqueCode } = this.props;
    const { builders } = this.state;
    if (!isEdit) {
      return this.defaultValues;
    }
    const apiReady =
      builder &&
      builder.uniqueCode &&
      builderUniqueCode &&
      builder.uniqueCode === builderUniqueCode;
    const stateSynced =
      builders &&
      builders.uniqueCode &&
      builderUniqueCode &&
      builders.uniqueCode === builderUniqueCode;
    const merged = apiReady
      ? {
          ...this.defaultValues,
          ...builder,
          ...(stateSynced ? builders : {})
        }
      : { ...this.defaultValues, ...builders };
    return {
      ...merged,
      isVerification: toFormCheckboxInt(merged.isVerification)
    };
  };

  render() {
    const {
      isDialogShow,
      onCloseDialog,
      isEdit,
      submitErrors,
      builder,
      isDialogDeleteShow
    } = this.props;
    const { builders, clientError } = this.state;
    // if (builders?.agreementUser === null) {
    //   builders.agreementUser = "";
    // }

    // if (builders?.agreementUserMail === null) {
    //   builders.agreementUserMail = "";
    // }

    // if (builders?.agreementUserPhone === null) {
    //   builders.agreementUserPhone = "";
    // }

    return (
      <>
        <CommonDialog
          title={isEdit ? "顧客情報編集" : "顧客情報登録​"}
          isDialogShow={isDialogShow}
          initialValues={this.getFormInitialValues()}
          onSubmit={this.onSubmit}
          isEdit={isEdit}
          onClose={onCloseDialog}
          fieldList={isEdit ? this.fieldListEdit : this.fieldList}
          submitButtonTitle={"登録"}
          submitErrors={clientError ? { ...submitErrors, ...clientError } : submitErrors}
          onDeleteClick={this.toggleDialogDelete}
          currentDate={this.currentDate}
        />
        <DialogDelete
          open={isDialogDeleteShow}
          onClose={this.toggleDialogDelete}
          PaperProps={{
            className: "dialog dialog-sign-up"
          }}
          onDeleteSubmit={this.onDeleteSubmit}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  submitErrors: state.storesReducer.error,
  builder: state.builderReducer.builderDetailReducer.builder,
  builders: state.builderReducer.builderListReducer.builders
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      postBuilder,
      fetchBuilderList,
      fetchBuilder,
      putBuilder,
      dispatchError,
      deleteBuilder
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopDialog));
